import { Component, OnInit } from '@angular/core';
// import { MatDialog, MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
// import { NgProgress, NgProgressService } from 'ngx-progressbar';
// import { ManageFormService } from '../../../services/manage-form/manage-form.service';
// import { SurveyBuilderService } from '../../../services/survey-builder/survey-builder.service';
import { SnackBarComponent } from 'dhwani-material-library';
import {
    SubmitConfirmationDialogComponent,
} from './../shared/submit-confirmation-dialog/submit-confirmation-dialog.component';
import { DeletePopupComponent } from './delete-popup/delete-popup.component';
import { ViewSequencePopupComponent } from './view-sequence-popup/view-sequence-popup.component';
import { DownloadDataDialogComponent } from './download-data-dialog/download-data-dialog.component';
// import { environment } from '../../../../environments/environment';
import { CommonFunctionService } from 'dhwani-material-library';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { FormLinkingComponent } from '../shared/form-linking/form-linking.component';
import { ImportFormsComponent } from './import-forms/import-forms.component'
import { TempModuleService } from '../form-translate/services/temp-module.service';
export enum FormDataDownloadType {
    PUBLISHED = 'published',
    UNPUBLISHED = 'unpublished'
}

@Component({
    selector: 'app-temp-forms',
    templateUrl: './temp-forms.component.html',
    styleUrls: ['./temp-forms.component.css'],
    providers:[TempModuleService]
})
export class TempFormsComponent implements OnInit {
    loaderState: boolean = true;
    surveyForms = [];
    language: string = 'en';
    project_name: string = sessionStorage.getItem('project_name');
    form_name: string = sessionStorage.getItem('form_name');
    allowedFinalActions: any = {}
    progressRef: NgProgressRef;
    webFormBaseUrl: any='https://stgwebform.dhwaniris.in/';

    constructor(
        private manageFormServices: TempModuleService,
        // private loaderService: LoaderService,
        public ngProgress: NgProgress,
        public surveyBuilderService: TempModuleService,
        public snackBar: MatSnackBar,
        public router: Router,
        public dialog: MatDialog,
        private commonService: CommonFunctionService,
    ) { 
        this.allowedFinalActions = this.commonService.getAllowedAction(
            'tempforms',
            'tempforms',
            '',
        );
        console.log("this.allowedFinalActions survey" ,this.allowedFinalActions)
    }

    ngOnInit() {
        this.progressRef = this.ngProgress.ref('myProgress');
        this.getForms();

    }

    getForms() {
        this.progressRef.start();
        // this.loaderService.showLoader($);
        this.manageFormServices.getTempForms().subscribe(
            cardResponse => this.onGettingTempFormSuccess(cardResponse),
            error => this.onGettingTempFormFail(error)
        );
    }

    openDownloadDialog(form) {
        const dialogRef = this.dialog.open(
            DownloadDataDialogComponent,
            {
                width: '600px',
                data: {
                    form
                }
            }
        );
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.downloadFormData(form, result)
            }

        })
    }

    private onGettingTempFormSuccess(cardResponse: any) {
        this.loaderState = false;
        this.progressRef.complete();
        if (cardResponse.success === true) {
            this.progressRef.complete();
            this.surveyForms = cardResponse.data;
            let allFormTitle = cardResponse.data.flatMap(item => [{ "formId": item.formId, "title": item.language[0].title, "_id": item._id, "publishedFormId": item.publishedFormId }]);
            sessionStorage.setItem('allFormTitle', JSON.stringify(allFormTitle));
            // this.loaderService.hideLoader($);
        } else console.log('Error:', cardResponse.message);
    }

    private onGettingTempFormFail(error: any) {
        console.log('Error', error);
    }

    formDeleteHandler(form) {
        let dialogRef = this.dialog.open(DeletePopupComponent, {
            width: '400px',
            data: {
                title: form.language[0].title
            }
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.snackBar.open('Deleting form');
                this.manageFormServices
                    .deleteForm(form._id)
                    .then(response => {
                        if (response['success']) {
                            this.snackBar.dismiss();
                            this.getForms();
                        }
                    })
                    .catch(response => {
                        this.snackBar.dismiss();
                    });
            }
        });
    }

    revertPublishSurveyForms(id, formDetails){
        console.log("revrt", id, formDetails)
    }


    publishSurveyForms(id, formDetails) {
        let form;
        try {
            form = this.surveyForms.find(form => form.formId == id);
            this.surveyBuilderService
                .getFormDetails(form._id)
                .then((response: any) => {
                    let reportedDateOrder = response.data[0]['reportedDateOrder']
                    if (response.success) {
                        let questions = response.data[0]['language'].find(
                            l => l.lng == this.language
                        )['question'];
                        const dialogRef = this.dialog.open(
                            ViewSequencePopupComponent,
                            {
                                width: '600px',
                                data: {
                                    questions,
                                    copiedFormId: form.copiedFormId,
                                    formId: id,
                                    form,
                                    duplicateCheckQuestions: form.duplicateCheckQuestions,
                                    keyInfoOrders: form.keyInfoOrders,
                                    reportedDateOrder,
                                    formType:  formDetails.hasOwnProperty('formType') && formDetails.formType ? formDetails.formType : '', //'surveyorCreator',
                                    publishValidations: response['publishValidations'],
                                    nonBypassableOrders:response.data[0]['nonBypassableOrders']
                                    // nonBypassableOrders:['1', '2', '3']
                                }
                            }
                        );
                        dialogRef.afterClosed().subscribe(result => {
                            console.log("???",result)
                            if (result) {
                                this.manageFormServices
                                    .setViewSequence(
                                        {
                                            questions: result.questions,
                                            duplicateQuestions: result.duplicateQuestions,
                                            reportedDateOrder:parseInt(result.reportedDateOrder),
                                            nonBypassableOrders:result.nonBypassableOrders
                                        },
                                        form.formId
                                    )
                                    .then(response => {
                                        console.log("???",response)
                                        if (response['success']) {
                                            this.manageFormServices
                                                .publishForms(id, {
                                                    indicatorsCopy:result.dashboardIndicators,
                                                    vdpIndicatorsCopy:result.vdpIndicators
                                                })
                                                .subscribe(
                                                    res => {
                                                        this.loaderState = false;
                                                        this.progressRef.complete();
                                                        if (
                                                            res.success === true
                                                        ) {
                                                            this.snackBar.open(
                                                                'Published'
                                                            );
                                                            setTimeout(() => {
                                                                this.snackBar.dismiss();
                                                                this.getForms();
                                                            }, 3000);
                                                        } else {
                                                            console.log(
                                                                'Error:',
                                                                res.message
                                                            );
                                                        } // End ..
                                                    },
                                                    response => {
                                                        this.snackBar.dismiss();
                                                        try {
                                                            response = JSON.parse(
                                                                response._body
                                                            );
                                                            let error =
                                                                response[
                                                                'message'
                                                                ];
                                                            this.snackBar.openFromComponent(
                                                                SnackBarComponent,
                                                                {
                                                                    data:
                                                                        typeof error ==
                                                                            'object'
                                                                            ? error
                                                                            : [
                                                                                error
                                                                            ],
                                                                    duration: 2500
                                                                }
                                                            );
                                                        } catch (e) {
                                                            let error =
                                                                'Some Error Occurred. Please try again.';
                                                            this.snackBar.openFromComponent(
                                                                SnackBarComponent,
                                                                {
                                                                    data:
                                                                        typeof error ==
                                                                            'object'
                                                                            ? error
                                                                            : [
                                                                                error
                                                                            ],
                                                                    duration: 4000
                                                                }
                                                            );
                                                        }
                                                    }
                                                );
                                        }
                                    })
                                    .catch(response => console.log(response));
                            }
                        });
                    }
                });
        } catch (e) {
            console.log(e);
        }
    }

    isFormExpiry(dateToCheck: string) {
        try {
            let formExpiryDate = new Date(dateToCheck);
            let currentDate = new Date();
            return currentDate > formExpiryDate;
        } catch (error) {
            console.error(`invalid date type`);
            return null;
        }
    }

    submitForm(form) {
        if (!form.isSubmitted) {
            const dialogRef = this.dialog.open(
                SubmitConfirmationDialogComponent,
                {
                    hasBackdrop: true
                }
            );
            dialogRef.afterClosed().subscribe(result => {
                if (result) {
                    this.surveyBuilderService
                        .submitForm(form._id)
                        .then((response: any) => {
                            if (response.success) {
                                if (result.submitOnly) {
                                    this.getForms();
                                } else {
                                    this.router.navigate([
                                        'manage-form/form-translate/',
                                        form._id
                                    ]);
                                }

                            }
                        })
                        .catch(response => {
                            try {
                                response = JSON.parse(response._body);
                                let error = response['message'];
                                this.snackBar.openFromComponent(
                                    SnackBarComponent,
                                    {
                                        data:
                                            typeof error == 'object'
                                                ? error
                                                : [error],
                                        duration: 2500
                                    }
                                );
                            } catch (e) {
                                let error =
                                    'Some Error Occurred. Please try again.';
                                this.snackBar.openFromComponent(
                                    SnackBarComponent,
                                    {
                                        data:
                                            typeof error == 'object'
                                                ? error
                                                : [error]
                                    }
                                );
                                setTimeout(() => {
                                    this.snackBar.dismiss();
                                }, 2500);
                            }
                        });
                }
            });
        } else {
            this.router.navigate(['manage-form/form-translate/', form._id]);
        }
    }

    downloadFormData(form: any, option: { formType: FormDataDownloadType, language?: string }) {
        if (option.formType === FormDataDownloadType.PUBLISHED) {
            this.downloadPublishedData(form, option.language);
        } else this.downloadUnpublishedData(form, option.language);
    }

    private downloadPublishedData(form: any, language = "en") {
        if (
            form.publishedFormId === null ||
            form.publishedFormId === undefined
        ) {
            return this.snackBar.open(
                'CSV not available for unpublished form',
                null,
                {
                    duration: 3000
                }
            );
        }
        const url = this.surveyBuilderService.downloadCSVOfForm({
            formId: form.publishedFormId,
            _id: form._id,
            formType: FormDataDownloadType.PUBLISHED,
            language: language
        });

        window.open(url);
    }

    private downloadUnpublishedData(form, language = "en") {
        const url = this.surveyBuilderService.downloadCSVOfForm({
            formId: form.formId,
            _id: form._id,
            formType: FormDataDownloadType.UNPUBLISHED,
            language: language
        });

        window.open(url);
    }

    handleBackNavi(path: string) {
        if(sessionStorage.getItem('hideHeader'))
        return true;
        if (path) {
            this.router.navigate([path]);
        } else {
            window.history.back();
        }
    }
    
    getWebFormUrl(projectId: string, formId:  string) {
        return `${this.webFormBaseUrl}projects/${projectId}/form/${formId}/response?form_source=external`
    }
    showLinking(data) {
        let current = this.surveyForms.find(res=>res._id == data._id);
        let childLinking =  [];
        let parentLinking = [];
            
        if(current){
            if(current.createDynamicOption){
                childLinking = this.surveyForms.filter(f=> current.createDynamicOption.map(m=> m.formId).indexOf(f.formId)>-1);
            }
            if(current.getDynamicOption){
                parentLinking = this.surveyForms.filter(f=> current.getDynamicOption.map(m=> m.formId).indexOf(f.publishedFormId)>-1);
            }
        }
        let dialogRef = this.dialog.open(FormLinkingComponent, {
            data :{
                data:[...parentLinking,current,...childLinking],
                isForm:true,
                formId:data.formId
            },
            maxWidth: '100vw',
            maxHeight: '100vh',
            height: '100%',
            width: '100%',
            panelClass: 'full-screen-modal'
        });



        dialogRef.afterClosed().subscribe(response => {
            if (response) {
             
            }
        });
    }
    downloadCSV(){
        let project_name = sessionStorage.getItem('project_name')
        let mapForm = this.surveyForms.map(res=> ({'formId':res.formId,'title':res['language'][0]['title'],'publishedFormId':res.publishedFormId}))
        let tablekey = ['formId','publishedFormId','title']
        let  tableHeading= ['Form Id','Published FormId','Title']
        this.commonService.downloadFileCsv(mapForm, project_name,tablekey,tableHeading)
    }
    importForms(){
        const dialogRef =   this.dialog.open(ImportFormsComponent,{
            data:this.surveyForms,
            maxWidth:'500px',
            width:'500px'
        })
        dialogRef.afterClosed().subscribe(res=>{
            console.log(res)
            if(res){
                 this.getForms();
            }
        })
    }
}
